/**
 * Formats a numeric amount with space as thousands separator and comma as decimal (Polish standard).
 * e.g. 100000.5 → "100 000,50"
 */
export function formatAmount(value: number | string | null | undefined): string {
  if (value === null || value === undefined) return "";
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "—";
  const fixed = num.toFixed(2);
  const [intPart, decPart] = fixed.split(".");
  const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, "\u00a0");
  return `${formattedInt},${decPart}`;
}
